import { render } from "./edit-totals.vue?vue&type=template&id=0826e503"
import script from "./edit-totals.vue?vue&type=script&lang=js"
export * from "./edit-totals.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__